// features/public-filters/domain/mappers/yearBuiltMapper.ts
import { Range } from '../FilterTypes';

/**
 * Parse a year built display string into a numeric value
 * @param value - Display string like "1900", "2020", "No min", "No max"
 * @returns Numeric value or null for unbounded
 */
export function parseYearBuiltValue(value: string): number | null {
  if (value === 'No min' || value === 'No max') return null;
  const parsed = parseInt(value);
  return isNaN(parsed) ? null : parsed;
}

/**
 * Format a numeric year built value for display
 * @param value - Numeric value or null
 * @param isMin - Whether this is a min or max value
 * @returns Display string
 */
export function formatYearBuiltValue(value: number | null, isMin: boolean): string {
  if (value === null) return isMin ? 'No min' : 'No max';
  return value.toString();
}

/**
 * Apply year built change from dropdown selection
 * @param currentRange - Current year built range
 * @param type - Whether changing min or max
 * @param value - New display value from dropdown
 * @returns New Range with updated value
 */
export function applyYearBuiltChange(
  currentRange: Range,
  type: 'min' | 'max',
  value: string,
): Range {
  const numericValue = parseYearBuiltValue(value);

  if (type === 'min') {
    return Range.create(numericValue, currentRange.max);
  } else {
    return Range.create(currentRange.min, numericValue);
  }
}
